<template>
  <div>
    <div class="container-fluid">
      <ul class="nav nav-tabs generic-tab pb-30px" id="myTab" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" id="edit-user-tab" data-toggle="tab" href="#edit-user" role="tab"
            aria-controls="edit-user" aria-selected="true">
            ویرایش اطلاعات پایه
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="edit-profile-tab" data-toggle="tab" href="#edit-profile" role="tab"
            aria-controls="edit-profile" aria-selected="false">
            ویرایش تصویر پروفایل
          </a>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane active" id="edit-user" role="tabpanel" aria-labelledby="edit-user-tab">
          <form method="POST" v-on:submit="handleUserSubmit">
            <div class="card card-item">
              <div class="card-body">
                <h3 class="fs-22 font-weight-regular pb-2">ویرایش اطلاعات</h3>
                <div class="divider"></div>
                <div class="form-row">
                  <div class="col-lg-6 form-group">
                    <label class="label-text">ویرایش نام</label>
                    <input onfocus="this.removeAttribute('readonly');" readonly v-model="editUser.Name"
                      class="form-control form-control-register pl-3" type="text" required />
                  </div>
                  <div class="col-lg-6 form-group">
                    <label class="label-text">نوع مهارت</label>
                    <Dropdown :loading="false" class="form-control form-control-register primCom" v-model="field"
                      :options="techFields" option-label="name" option-value="code"
                      placeholder="یک مورد را انتخاب کنید" />
                  </div>
                  <div class="col-lg-6 form-group">
                    <label class="label-text">ایمیل</label>
                    <input onfocus="this.removeAttribute('readonly');" readonly v-model="editUser.Email"
                      class="form-control form-control-register pl-3" type="text" />
                    <span class="text-color" v-if="msg.email">{{
                      msg.email
                    }}</span>
                  </div>
                  <div class="col-lg-6 form-group">
                    <label>رمزعبور</label>
                    <div class="input-group input-group-register-password mb-3">
                      <input onfocus="this.removeAttribute('readonly');" readonly @input="(event) =>
                          (editUser.Password = /^[A-Za-z0-9-!-\/:-@[-`{-~]*$/.test(
                            event.target.value
                          )
                            ? editUser.Password
                            : '')
                          " v-if="showPassword" v-model="editUser.Password" type="text"
                        class="form-control form-control-register-password" placeholder="گذرواژه را وارد کنید" required />
                      <input onfocus="this.removeAttribute('readonly');" readonly @input="(event) =>
                          (editUser.Password = /^[A-Za-z0-9-!-\/:-@[-`{-~]*$/.test(
                            event.target.value
                          )
                            ? editUser.Password
                            : '')
                          " v-if="!showPassword" v-model="editUser.Password" type="password"
                        class="form-control form-control-register-password" placeholder="گذرواژه را وارد کنید" required />
                      <div @click="toggleShow()" class="input-group-append input-group-append-password">
                        <button class="
                            btn
                            theme-btn-register theme-btn-transparent
                            toggle-password
                          " type="button">
                          <i style="font-size: 20px" v-if="!showPassword" class="la la-eye"></i>
                          <i style="font-size: 20px" v-if="showPassword" class="la la-low-vision"></i>
                        </button>
                      </div>
                    </div>
                    <span class="text-danger" v-if="msg.password">{{
                      msg.password
                    }}</span>
                  </div>

                  <div class="col-lg-12 form-group">
                    <label class="label-text">مهارت استاد</label>
                    <CkEditor @sendContent="getContentSkill" :content="initialDataSkill"></CkEditor>
                  </div>
                  <div class="col-lg-12 form-group">
                    <label class="label-text">بیو استاد</label>
                    <CkEditorBio @sendContentBio="getContentBio" :contentBio="initialDataBio"></CkEditorBio>
                  </div>
                </div>
              </div>
            </div>
            <div class="course-submit-btn-box pb-4">
              <button :disabled="working" type="submit" class="btn theme-btn">
                <div v-if="!working">ویرایش اطلاعات</div>
                <div v-if="working" class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </button>
            </div>
          </form>
        </div>
        <div class="tab-pane" id="edit-profile" role="tabpanel" aria-labelledby="edit-profile-tab">
          <form method="POST" v-on:submit="handleImageSubmit">
            <div class="card card-item">
              <div class="card-body">
                <h3 class="fs-22 font-weight-regular pb-2">
                  ویرایش تصویر پروفایل
                </h3>
                <div class="divider"></div>
                <div class="form-row">
                  <div class="form-group col-lg-12">
                    <div class="col-12 form-group">
                      <label class="label-text">تصویر شخص</label>
                      <div class="row">
                        <div class="file-upload-wrap col-6">
                          <input onfocus="this.removeAttribute('readonly');" readonly type="file"
                            v-on:change="handleImageUpload($event)" class="file-upload-input" />
                          <span v-if="image === ''" class="file-upload-text"><i
                              class="la la-cloud-upload mr-2 fs-18"></i>تصویر
                            را اینجا رها کنید یا برای آپلود کلیک کنید.</span>
                        </div>
                        <img v-if="ifPicExist(user.Profile)" class="img-fluid" :src="domain + user.Profile" style="
                            width: 120px !important;
                            height: 120px !important;
                          " alt="" />
                        <img v-if="!ifPicExist(user.Profile)" class="img-fluid" src="../assets/images/notfound.png" style="
                            width: 120px !important;
                            height: 120px !important;
                          " alt="" />
                      </div>
                    </div>
                  </div>
                  <div class="course-submit-btn-box pb-4">
                    <button :disabled="workingProfile" type="submit" class="btn theme-btn">
                      <div v-if="!workingProfile">ویرایش تصویر</div>
                      <div v-if="workingProfile" class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <Toast position="top-left" />
</template>

<script>
import ProgressBar from "primevue/progressbar";
import axios from "axios";
import ls from "localstorage-slim";
import * as cnfigs from "../configs";
import Toast from "primevue/toast";
import Preparing from "../components/Preparing.vue";
import CkEditor from "../components/CkEditor.vue";
import CkEditorBio from "../components/CkEditor2.vue";
import { teacherMajors } from "../constants.js";
import { DOMAIN } from "../configs";

export default {
  name: "Profile",
  components: {
    ProgressBar,
    Toast,
    Preparing,
    CkEditor,
    CkEditorBio,
  },
  created() {
    this.user = JSON.parse(ls.get("user"));
    this.username = this.user.Name;
    this.editUser = this.user;
    this.initialDataBio = this.editUser.Bio;
    this.initialDataSkill = this.editUser.Skill;
    this.field = this.editUser.Field;
  },

  data() {
    return {
      failedPic: false,
      domain: DOMAIN,
      field: "",
      initialDataSkill: "",
      initialDataBio: "",
      ckContentBio: "",
      ckContentSkill: "",
      selectedSkillType: {},
      msg: [],
      showProgressValue: false,
      working: false,
      workingProfile: false,
      cnfigs: cnfigs,
      id: "",
      submitted: false,
      image: "",
      chooseProfile: "بدون عکس ",
      selectedRole: null,
      user: {},
      editUser: {},
      username: "",
      progressValue: 0,
      withpro: false,
      withoutpro: true,
      showPassword: false,
      techFields: teacherMajors,
    };
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  watch: {
    withpro() {
      this.withoutpro = !this.withpro;
    },
    withoutpro() {
      this.withpro = !this.withoutpro;
    },
  },
  methods: {
    ifPicExist(p) {
      if (p === "no" || p === undefined || p === null) {
        return false;
      } else {
        return true;
      }
    },
    getContentSkill(e) {
      this.ckContentSkill = e;
    },
    getContentBio(event) {
      this.ckContentBio = event;
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    handleImageUpload(event) {
      this.image = event.target.files;
    },
    async saveUserWP() {
      let formData = new FormData();
      formData.append("image", this.image[0]);
      formData.append("uid", this.editUser.Uid);

      this.submitted = true;
      this.showProgressValue = true;
      await axios
        .post("/api/v1/teacher/user/edit/profile", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            this.progressValue = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
        .then((response) => {
          if (response.status == 200) {
            this.progressValue = 0;
            this.image = "";
            this.submitted = false;
            this.$toast.add({
              severity: "success",
              summary: "پروفایل شما به روزرسانی شد",
              life: 3000,
            });
            ls.set("user", JSON.stringify(response.data.user));
            this.user = JSON.parse(ls.get("user"));
            this.editUser = this.user;
            this.$router.go();
          } else {
            this.progressValue = 0;
            this.image = "";
            this.submitted = false;
            this.$toast.add({
              severity: "error",
              summary: "خطا در انجام عملیات",
              detail: "لطفا مجدد تلاش کنید",
              life: 3000,
            });
          }
        });
      this.workingProfile = false;
      // this.user = {}
    },
    async saveUser() {
      await axios
        .post("/api/v1/teacher/user/edit", {
          name: this.editUser.Name,
          password: this.editUser.Password,
          skill:
            this.ckContentSkill === ""
              ? this.initialDataSkill
              : this.ckContentSkill,
          skilltype: this.techFields.find((s) => s.code === this.field).name,
          field: this.field,
          bio:
            this.ckContentBio === "" ? this.initialDataBio : this.ckContentBio,
          email: this.editUser.Email,
          type: this.editUser.Type,
          uid: this.editUser.Uid,
        })
        .then((response) => {
          if (response.status == 200) {
            this.$toast.add({
              severity: "success",
              summary: "پروفایل شما به روزرسانی شد",
              life: 3000,
            });
            ls.set("user", JSON.stringify(response.data.user));
            this.user = JSON.parse(ls.get("user"));
            this.editUser = this.user;
            this.$router.go();
          } else {
            this.$toast.add({
              severity: "error",
              summary: "خطا در انجام عملیات",
              detail: "لطفا مجدد تلاش کنید",
              life: 3000,
            });
          }
        });
      this.working = false;

      // this.user = {}
    },
    handleUserSubmit(e) {
      e.preventDefault();
      this.working = true;
      this.saveUser();
    },
    handleImageSubmit(e) {
      e.preventDefault();
      if (this.image === "") {
        this.$toast.add({
          severity: "error",
          summary: "خطا در انجام عملیات",
          detail: "تصویری برای ویرایش وارد نشده است",
          life: 3000,
        });
        return;
      }
      this.workingProfile = true;
      this.saveUserWP();
    },
  },
};
</script>

<style>
p-image {
  height: 200;
  width: 200;
  display: none;
}
</style>
